/* Back Door email popup (sections/bd-email-popup.liquid).

   When it shows (storefront, "Enable popup" on)
   - never on the first page of a visit (an ad / link landing page) and
     never on product or cart pages: from the 2nd page view of the browser
     session (sessionStorage page counter), after the delay;
   - at most once per browser session (sessionStorage);
   - not while a timestamped record in localStorage says the visitor closed
     it (dismiss days) or signed up (success days). Key is versioned
     (bd_email_popup_v1, from "Campaign version"). The email is never stored.
   - Submit: always Shopify's NATIVE form submit (POST /contact, form_type=
     customer, contact[email], contact[tags]) - never fetch/AJAX: Shopify's
     spam protection adds its CAPTCHA token to the native submit, a fetch
     post is refused ("Missing CAPTCHA token", gotcha #61). Before the
     browser submits, the scroll position + a from-popup flag are saved in
     sessionStorage; on the page Shopify returns to, this section renders
     data-bd-popup-posted="success" / "error" (+ Shopify's error text), the
     popup reopens on that step at the saved position and the
     customer_posted / #BdEmailPopupForm / #ContactFooter bits are removed
     from the URL. The popup only reacts to ITS post (anchor or session
     flag); a footer newsletter post is ignored for that page view.
   Welcome code (success step, only rendered by Shopify after a successful
   signup): added to the cart with the Cart Ajax API (POST cart/update.js
   { discount }) - the cart items are untouched. Not added when the cart
   already has any discount (another code, an automatic discount - never
   replaces one). Status from documented Ajax cart fields only:
   "Applied" = the code has a discount allocation in the returned cart
   (cart_level_discount_applications[].total_allocated_amount or an item's
   line_level_discount_allocations[].amount, matched by type discount_code
   + title = code). No allocation = no claim: "Use it at checkout" (empty
   bag) / "Not applied to the items in your bag" / "Enter at checkout".
   Then Dawn's cartUpdate event refreshes the drawer (cart.js).
   Theme Editor: never auto-opens; opens for "Preview in Theme Editor" or
   while the section is selected; never posts or stores anything there. */
(function () {
  if (customElements.get('bd-email-popup')) return;

  var FORM_ID = 'BdEmailPopupForm';
  var SUBMIT_FLAG = 'bd_email_popup_submitted';
  var SCROLL_KEY = 'bd_email_popup_scroll';
  var NO_AUTO_OPEN = ['product', 'cart'];
  var DAY = 24 * 60 * 60 * 1000;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function store(area, action, key, value) {
    try {
      var s = area === 'local' ? window.localStorage : window.sessionStorage;
      if (action === 'get') return s.getItem(key);
      if (action === 'set') s.setItem(key, value);
      if (action === 'remove') s.removeItem(key);
    } catch (e) {}
    return null;
  }

  class BdEmailPopup extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.bd-popup__card');
      // Everything is looked up inside this element - the footer newsletter
      // is also a Shopify customer form with a contact[email] field.
      this.form = this.querySelector('#' + FORM_ID);
      this.input = this.form && this.form.elements['contact[email]'];
      this.errorEl = this.querySelector('[data-bd-popup-error]');
      var postedEl = this.querySelector('[data-bd-popup-posted]');
      this.posted = postedEl ? postedEl.dataset.bdPopupPosted : '';
      this.key = this.dataset.key || 'bd_email_popup_v1';
      this.designMode = this.dataset.designMode === 'true';
      this.isOpen = false;
      this.onKeydown = this.onKeydown.bind(this);

      this.addEventListener('click', this.onClick.bind(this));
      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

      if (this.designMode) this.initEditor();
      else this.initStorefront();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.classList.remove('bd-popup-lock');
    }

    initStorefront() {
      if (this.dataset.enabled !== 'true') return;
      var fromPopup = window.location.hash === '#' + FORM_ID || store('session', 'get', SUBMIT_FLAG) === '1';
      if (this.posted && fromPopup) {
        store('session', 'remove', SUBMIT_FLAG);
        var savedY = this.restoreAfterNativePost();
        if (this.posted === 'success') {
          this.remember('subscribed');
          this.open('success');
          this.applyCode();
        } else {
          this.open('form');
        }
        // Close (X / Start shopping) returns to the saved spot even if the
        // page was not tall enough yet when it was first restored.
        if (typeof savedY === 'number') this.scrollY = savedY;
        return;
      }
      if (this.posted) return; // the footer form was just posted

      // Page views in this browser session: the landing page never auto-opens.
      var pages = (parseInt(store('session', 'get', this.key + '_pages'), 10) || 0) + 1;
      store('session', 'set', this.key + '_pages', String(pages));
      if (pages < 2 || NO_AUTO_OPEN.indexOf(this.dataset.template) !== -1) return;

      if (store('session', 'get', this.key + '_seen') === '1') return;
      var raw = store('local', 'get', this.key);
      if (raw) {
        try {
          var record = JSON.parse(raw);
          var days = record.s === 'subscribed' ? this.dataset.successDays : this.dataset.dismissDays;
          if (record.t && Date.now() - record.t < (parseFloat(days) || 0) * DAY) return;
        } catch (e) {}
      }
      var self = this;
      var delay = Math.max(1, parseFloat(this.dataset.delay) || 4) * 1000;
      this.timer = window.setTimeout(function () {
        store('session', 'set', self.key + '_seen', '1');
        self.open('form');
      }, delay);
    }

    initEditor() {
      var self = this;
      var id = this.dataset.sectionId;
      var step = this.dataset.previewState || 'form';
      if (this.dataset.preview === 'true') this.open(step);
      document.addEventListener('shopify:section:select', function (event) {
        if (event.detail && event.detail.sectionId === id) self.open(step);
      });
      document.addEventListener('shopify:section:deselect', function (event) {
        if (event.detail && event.detail.sectionId === id && self.dataset.preview !== 'true') self.close();
      });
    }

    // After Shopify's native post: back where the customer was, URL cleaned.
    // Returns the restored scroll position (or null).
    restoreAfterNativePost() {
      var saved = store('session', 'get', SCROLL_KEY);
      store('session', 'remove', SCROLL_KEY);
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        if (url.hash === '#' + FORM_ID || url.hash === '#ContactFooter') url.hash = '';
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (e) {}
      if (!saved) return null;
      try {
        var record = JSON.parse(saved);
        if (record.path === window.location.pathname) {
          var restore = function () {
            window.scrollTo(0, record.y);
          };
          restore();
          window.addEventListener('load', restore, { once: true });
          return record.y;
        }
      } catch (e) {}
      return null;
    }

    // Welcome code -> cart (Cart Ajax API). Never claims "applied" unless
    // Shopify says so; never replaces a discount already in the cart.
    applyCode() {
      var box = this.querySelector('[data-bd-popup-code]');
      if (!box) return;
      var code = box.dataset.bdPopupCode;
      var status = box.querySelector('[data-bd-popup-code-status]');
      var say = function (state) {
        if (!status) return;
        status.dataset.state = state;
        status.textContent = status.dataset[state] || '';
      };
      // Documented Ajax cart fields only (no discount_codes / applicable).
      var mine = function (application) {
        return !!application && application.type === 'discount_code' && String(application.title || '').toLowerCase() === code.toLowerCase();
      };
      var lineAllocations = function (cart) {
        var list = [];
        (cart.items || []).forEach(function (item) {
          list = list.concat(item.line_level_discount_allocations || []);
        });
        return list;
      };
      // Amount (cents) the code actually takes off, order or item level.
      var allocated = function (cart) {
        var total = 0;
        (cart.cart_level_discount_applications || []).forEach(function (application) {
          if (mine(application)) total += application.total_allocated_amount || 0;
        });
        lineAllocations(cart).forEach(function (allocation) {
          if (mine(allocation.discount_application)) total += allocation.amount || 0;
        });
        return total;
      };
      var otherDiscount = function (cart) {
        if ((cart.cart_level_discount_applications || []).some(function (application) { return !mine(application); })) return true;
        if (lineAllocations(cart).some(function (allocation) { return !mine(allocation.discount_application); })) return true;
        return cart.total_discount > 0 && allocated(cart) === 0;
      };
      var report = function (cart) {
        if (allocated(cart) > 0) say('applied');
        else say(cart.item_count > 0 ? 'notapplied' : 'later');
      };
      var json = function (response) {
        return response.ok ? response.json() : Promise.reject(response.status);
      };
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      say('pending');
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(json)
        .then(function (cart) {
          if (allocated(cart) > 0) return say('applied');
          if (otherDiscount(cart)) return say('existing');
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code })
          })
            .then(json)
            .then(function (updated) {
              report(updated);
              // Drawer footer (discount line, subtotal, free-shipping bar)
              // re-renders through Dawn's own cartUpdate subscriber.
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && updated.item_count > 0) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bd-email-popup', cartData: updated });
              }
            });
        })
        .catch(function () {
          say('manual');
        });
    }

    remember(state) {
      if (this.designMode) return;
      store('local', 'set', this.key, JSON.stringify({ s: state, t: Date.now() }));
    }

    open(step) {
      if (!this.isOpen) {
        this.lastFocus = document.activeElement;
        this.scrollY = window.scrollY;
      }
      this.showStep(step || 'form');
      if (!this.isOpen) {
        this.isOpen = true;
        this.hidden = false;
        document.documentElement.classList.add('bd-popup-lock');
        document.addEventListener('keydown', this.onKeydown);
        var self = this;
        window.requestAnimationFrame(function () {
          self.classList.add('is-visible');
        });
      }
      // Initial focus = the dialog itself (never an input): the page must not
      // move and no phone keyboard should open. The customer taps the field.
      // Shopify errors are announced by the role="alert" message.
      var target = step === 'success' ? this.querySelector('[data-bd-popup-success-title]') : this.card;
      if (target) {
        window.setTimeout(function () {
          target.focus({ preventScroll: true });
        }, 60);
      }
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove('is-visible');
      document.documentElement.classList.remove('bd-popup-lock');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.step !== 'success') this.remember('dismissed');
      var self = this;
      window.setTimeout(function () {
        if (!self.isOpen) self.hidden = true;
      }, reduceMotion.matches ? 0 : 250);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      // The page never moves while the popup is open; if a browser shifted it
      // anyway (scroll lock / toolbar resize), put it back where it was.
      if (typeof this.scrollY === 'number' && Math.abs(window.scrollY - this.scrollY) > 1) {
        window.scrollTo(0, this.scrollY);
      }
    }

    showStep(step) {
      this.step = step;
      this.querySelectorAll('[data-bd-popup-step]').forEach(function (el) {
        el.hidden = el.dataset.bdPopupStep !== step;
      });
    }

    onClick(event) {
      if (event.target.closest('[data-bd-popup-close]')) {
        event.preventDefault();
        this.close();
        return;
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.filter.call(
        this.card.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'),
        function (el) {
          return el.offsetParent !== null && !el.closest('[hidden]');
        }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !this.card.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !this.card.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }

    onSubmit(event) {
      var value = (this.input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        event.preventDefault();
        this.input.setAttribute('aria-invalid', 'true');
        this.input.setAttribute('aria-describedby', this.errorEl.id);
        this.errorEl.textContent = 'Enter a valid email address.';
        this.errorEl.hidden = false;
        this.input.focus({ preventScroll: true });
        return;
      }
      if (this.designMode) {
        // Editor: never post; show the success step instead.
        event.preventDefault();
        this.open('success');
        return;
      }
      // Valid email: let the browser + Shopify submit natively (CAPTCHA,
      // spam protection, redirect). Only remember where we were.
      this.prepareNativeSubmit();
    }

    prepareNativeSubmit() {
      store('session', 'set', SUBMIT_FLAG, '1');
      store('session', 'set', SCROLL_KEY, JSON.stringify({ path: window.location.pathname, y: this.isOpen ? this.scrollY : window.scrollY }));
    }
  }

  customElements.define('bd-email-popup', BdEmailPopup);
})();
